module.exports = __webpack_public_path__ + "img/logo.ed3b2e00.png";